export class StringUtils {
    static isNullOrEmpty(value: any): boolean {
        return value === undefined || value === null || value === '';
    }

   static sanitizeUsername(text: string): string {
       return text.replace(/\s+/g, '_');
    }
}